import { ComponentProps, FC } from 'react';

import { cn } from '@/lib/utils';

interface ModalFooterProps extends ComponentProps<'div'> {}

export const ModalFooter: FC<ModalFooterProps> = ({ children, className, ...props }) => {
  return (
    <div {...props} className={cn('flex items-center justify-end gap-2 mt-4', className)}>
      {children}
    </div>
  );
};
